/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_TitleInputs */

const cs_social_templates_title = /** @type {(inputs: Social_Templates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociální šablony`)
};

const en_social_templates_title = /** @type {(inputs: Social_Templates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social templates`)
};

/**
* | output |
* | --- |
* | "Social templates" |
*
* @param {Social_Templates_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_title = /** @type {((inputs?: Social_Templates_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_title(inputs)
	return cs_social_templates_title(inputs)
});